import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { NavigateEstablishment } from "../../../core/interfaces/navigate-for-categorie-establishment/navegiate-for-categorie.establishment.service";
import { EstablishmentsForCategorieResponse } from "../../establishments-for-categorie/interface/establishments-for-categorie.interface";
import { Observable } from "rxjs";
import { AuthService } from "../../../core/service/auth.service";

@Injectable({
  providedIn: 'root'
})
export class EstablishmentsGralListService {
  private readonly apiUrl=environment.apiUrl
  constructor(private http: HttpClient,
    private authService:AuthService
  ) {

  }


  loadListEstablishmentsGral(NavigateEstablishmentRequest: NavigateEstablishment):Observable< EstablishmentsForCategorieResponse>{

    if(this.authService.isLoggedIn()){
const tokenUser = this.authService.getToken();
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${tokenUser}`,
      'Content-Type': 'application/json'
    });
  return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/type_establishmentsGral`, NavigateEstablishmentRequest, { headers })
    }
  return this.http.post<EstablishmentsForCategorieResponse>(`${this.apiUrl}/type_establishmentsGral`, NavigateEstablishmentRequest, )
  }
}
